import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/consumer"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/consumer',
          },
        ]}
      />
    }
  >
    <Route path="consumer" element={<AsyncPage />} />
  </Route>
);
